import React, { useState } from "react";
import {
  CommonActionModal,
  CustomLinearProgress,
  MuiBox,
  MuiTypography,
} from "components/atoms";
import { Button, Divider } from "@mui/material";
import {
  HomeSidebarContent,
  SettingsSidebarContent,
} from "components/molecules";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

//SVGs
import Logo from "assets/images/svg-icons/bigfootDriveLogo.svg";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  closeCenterModal,
  openCenterModal,
} from "store/slices/CenterModal.slice";
import { useNavigate } from "react-router-dom";

const DriveSidebar = ({ onMenuClick }) => {
  const location = useLocation();
  const isSettings = location.pathname.startsWith("/drive/settings");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setting } = useSelector((state) => state.general);
  const dispatch = useDispatch();
  const [isDismiss, setIsDismiss] = useState(() => {
    try {
      return sessionStorage.getItem("isDismiss") === "true";
    } catch {
      return false;
    }
  });

  const handleDismiss = () => {
    setIsDismiss(true);
    sessionStorage.setItem("isDismiss", "true");
  };

  const usedPercent =
    setting?.used_drive_storage && setting?.max_drive_storage
      ? (Number(setting.used_drive_storage) * 100) /
      Number(setting.max_drive_storage)
      : 0;
  const isStorageCritical = usedPercent > 80;
  // const navigate = useNavigate();
  return (
    <MuiBox
      sx={{
        width: "250px",
        flexShrink: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <MuiBox
        sx={{
          p: "16px 16px 0 16px",
          flexShrink: 0,
          backgroundColor: "background.gray200",
        }}
      >
        <MuiBox
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            mb: "16px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/drive/home")}
        >
          <MuiBox sx={{ height: "24px", width: "24px" }}>
            <img src={Logo} alt="Bigfoot logo" className="img-full" />
          </MuiBox>
          <MuiTypography fontWeight="500" variant="20" color="text.dark">
            {t("common.bigfootDrive")}
          </MuiTypography>
        </MuiBox>
        <Divider />
      </MuiBox>
      <MuiBox
        sx={{
          flex: 1,
          overflowY: "auto",
          p: "16px",
          scrollbarWidth: "none",
        }}
      >
        <MuiBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            height: "100%",
          }}
        >
          {isSettings ? (
            <SettingsSidebarContent onMenuClick={onMenuClick} />
          ) : (
            <HomeSidebarContent onMenuClick={onMenuClick} />
          )}

          <MuiBox
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              mt: "auto",
            }}
          >
            {!isDismiss && (
              <MuiBox
                sx={{
                  p: "12px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  backgroundColor: "background.blue200",
                  borderRadius: "8px",
                }}
              >
                <MuiBox
                  sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <MuiTypography
                    fontWeight="600"
                    variant="14"
                    color="text.blue1300"
                  >
                    {t("setting.usedSpace")}
                  </MuiTypography>
                  <MuiTypography
                    fontWeight="400"
                    variant="14"
                    color="text.lightgray"
                  >
                    {t("setting.youHaveUsedAvailableSpace", { value: usedPercent.toFixed(2) })}
                  </MuiTypography>
                </MuiBox>
                <MuiBox
                  sx={{
                    bgColor: "background.progressgray",
                  }}
                >
                  <CustomLinearProgress
                    value={usedPercent}
                    isCritical={isStorageCritical}
                  />
                </MuiBox>
                <MuiBox
                  sx={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <Button
                    variant="text"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "text.gray1200",
                      p: 0,
                    }}
                    onClick={() => handleDismiss()}
                  >
                    {t("setting.dismiss")}
                  </Button>

                  <Button
                    onClick={() =>
                      dispatch(
                        openCenterModal({
                          content: (
                            <CommonActionModal
                              title={t("modal.upgradePlan.needMoreStorage")}
                              BodyTitle={t("modal.upgradePlan.needMoreStorageDescr")}
                              action={t("setting.upgradePlan")}
                              onClick={() => {
                                dispatch(closeCenterModal());
                                window.open(
                                  "https://mail.dev.bigfootmail.com/settings/upgrade-plan",
                                  "_blank",
                                );
                              }}
                            />
                          ),
                        }),
                      )
                    }
                    variant="text"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "primary.main",
                      p: 0,
                    }}
                  >
                    {t("setting.upgradePlan")}
                  </Button>
                </MuiBox>
              </MuiBox>
            )}
            <MuiBox sx={{ p: "12px" }}>
              <MuiTypography
                fontWeight="400"
                variant="12"
                color="text.darkBlack"
              >
                {t("setting.bigFootMailLLCAllRightsReserved", {
                  value: dayjs().format("YYYY"),
                })}
              </MuiTypography>
            </MuiBox>
          </MuiBox>
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};

export default DriveSidebar;
